const PATTERN = {
    alphaNum: /^[a-zA-Z0-9.]*$/,
    period: /^(?!.*\.$)[^.].*[^.]$/,
    consecutivePeriod: /(\.)\1+/,
};

// Why is the `min` username length so long? We allow
// single character Yats, but required `8` character usernames?
export const USERNAME_LENGTH = {
    min: 8,
    max: 16,
};

export const USERBIO_LENGTH = {
    min: 0,
    max: 160,
};

export function validateUsernameLength(value = '') {
    return value.length >= USERNAME_LENGTH.min && value.length <= USERNAME_LENGTH.max;
}

export function validateUserBioLength(value = '') {
    return value.length <= USERBIO_LENGTH.max;
}

export function i18nUsernameValidationKeys(value = '') {
    const validLength = validateUsernameLength(value);

    // TODO: Why do we test each of these seperately? Why not just
    // have a single error message for "invalid characters"?
    const validAlphaNumeric = PATTERN.alphaNum.test(value);
    const validPeriods = PATTERN.period.test(value);

    // This regex is confusing because it is the opposite of the other tests.
    const invalidConsecutivePeriods = PATTERN.consecutivePeriod.test(value);

    const messages = [
        validLength ? '' : 'username_error_length',
        validAlphaNumeric ? '' : 'username_error_alpha_numeric',
        validPeriods ? '' : 'username_error_pre_post_period',
        invalidConsecutivePeriods ? 'username_error_consecutive_period' : '',
    ];

    return messages.filter((message) => message.length);
}

export function validateUsername(value = '') {
    const validLength = validateUsernameLength(value);
    const hasErrors = i18nUsernameValidationKeys(value);

    return validLength && !hasErrors.length;
}
